"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
// Radio component is a controlled component
var Radio = function (props) {
    var checked = props.checked, value = props.value, className = props.className, inline = props.inline, disabled = props.disabled, block = props.block, style = props.style, hideRadio = props.hideRadio, handleOnChange = props.onChange, children = props.children;
    var classes = classNames('form_group__radio', {
        'form_group__radio--checked': checked,
        'form-group__radio--inline': inline,
        'form-group__radio--disabled': disabled,
        'form-group__radio--hidden': hideRadio,
        'form-group__radio-block': block
    }, className);
    return (React.createElement("label", { className: classes, style: style },
        React.createElement("input", { type: "radio", checked: checked, disabled: disabled, value: value, onChange: handleOnChange }),
        React.createElement("span", { className: "form-group__radio-indicator" }),
        block ? (React.createElement("div", { className: "form-group__radio-block__content" }, children)) : (children)));
};
exports.default = Radio;
//# sourceMappingURL=Radio.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Radio/Radio.js
// module id = 274
// module chunks = 0